import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m20 16-4-4 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4 8 4 4-4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 4-4 4-4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 20 4-4 4 4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Snowflake";
const Snowflake = memo(themed(Icon));
export {
  Snowflake
};
//# sourceMappingURL=snowflake.js.map
